import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from '../../interfaces/breadcrumb';
import { BreadcrumbsService } from '../../services/breadcrumbs.service';
import {RouterLink} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-breadcrumbs',
    imports: [RouterLink, TranslateModule],
    templateUrl: './breadcrumbs.component.html',
    styleUrl: './breadcrumbs.component.scss',
    standalone: true
})
export class BreadcrumbsComponent implements OnInit {
  breadcrumbs: Breadcrumb[] = [];
  show = true;
  constructor(private $breadcrumbs: BreadcrumbsService) {}
  ngOnInit(): void {
    this.$breadcrumbs.crumbs.subscribe((res) => (this.breadcrumbs = res));
    this.$breadcrumbs.stateShow.subscribe((show) => (this.show = show));
  }
}
